import striptags from 'striptags';

export function stripHtml(html, allowedTags, replacement) {
  return striptags(html, allowedTags, replacement);
}
